<template>
  <v-layout>
    <v-flex xs12 sm10 offset-sm1 >
      <v-card>
        <v-card-title class="primary justify-center">
          <v-container pa-0>
            <v-layout fluid row wrap>
              <v-flex xs12>
                <v-btn
                  v-on:click="redireccion"
                  absolute
                  dark
                  small
                  fab
                  center
                  right
                  class="accent"
                  >
                  <v-icon>add</v-icon>
                </v-btn>
              <h6 class="white--text text-xs-center">Compras</h6>

              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm3>
                  <v-dialog
                    persistent
                    v-model="menu"
                    lazy
                    full-width
                  >
                    <v-text-field
                      dark
                      slot="activator"
                      label="Desde"
                      v-model="desde"
                      prepend-icon="event"
                      data-vv-delay="100"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="desde" scrollable>
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save(), filtrarfechainicio()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
              <v-flex xs12 sm3>
                <v-dialog
                    persistent
                    v-model="menu2"
                    lazy
                    full-width
                  >
                    <v-text-field
                      dark
                      slot="activator"
                      label="Hasta"
                      v-model="hasta"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="hasta" scrollable >
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save(), filtrarfechafin()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-title>
          <v-flex style="overflow-x: auto">
             <table class="table">
              <tr>
                <th></th>
                <th></th>
                <th>Proveedor</th>
                <th>Fecha</th>
                <th>Total</th>
              </tr>
            <tbody>
              <tr v-for="compra in getcompras.results">
                <td>
                  <v-btn icon class="red--text text--darken-2" @click="eliminar(compra)">
                    <v-icon>delete</v-icon>
                  </v-btn></td>
                <td>
                  <v-btn icon class="blue--text text--darken-2" @click="editarcompra(compra)">
                    <v-icon>edit</v-icon>
                  </v-btn></td>
                <td class="text-xs-center">{{compra.proveedor_name}}</td>
                <td class="text-xs-center">{{compra.fecha_facturacion | formatDate}}</td>
                <td class="text-xs-center">Q. {{compra.cantidad}}</td>
              </tr>
            </tbody>
          </table>
          </v-flex>
         <v-card-actions class="justify-center">
          <v-layout row justify-center align-center>
             <v-btn fab dark small primary @click="prev(getcompras.previous)" v-if="getcompras.previous">
              <v-icon dark>skip_previous</v-icon>
            </v-btn>
             <v-btn fab dark small primary @click="next(getcompras.next)" v-if="getcompras.next">
            <v-icon>skip_next</v-icon>
          </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>


  </v-layout>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    created: function () {
      this.$store.dispatch('getCompras')
    },
    data () {
      return {
        menu: false,
        menu2: false,
        fechainicio: '',
        fechafin: '',
        search: '',
        desde: '',
        hasta: ''
      }
    },
    methods: {
      redireccion: function () {
        this.$router.push('/comprasadd')
      },
      editarcompra: function (compra) {
        this.$store.commit('setcompra', compra)
        this.$router.push('/comprasadd')
      },
      eliminar (compra) {
        let r = confirm(' esta seguro que desea eliminar ' + compra.proveedor_name)
        if (r === true) {
          this.$store.dispatch('eliminarcompra', compra)
        }
      }
    },
    computed: {
      ...mapGetters([
        'getcompras'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// CompraTemporal.vue?5274d2fa